var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxDirections = function Svg18PxDirections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 1.75v14.5M5.75 16.25h6.5M9 6.25H3.884a1 1 0 0 1-.669-.257l-1.389-1.25a1 1 0 0 1 0-1.487l1.389-1.25c.184-.165.422-.257.669-.257H9M11.495 10.75h2.616a1 1 0 0 0 .669-.257l1.389-1.25a1 1 0 0 0 0-1.487l-1.389-1.25a1 1 0 0 0-.669-.257h-2.616"
  })));
};
export default Svg18PxDirections;